import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import Header from "./components/Header";
import Signup from "./components/Signup";
import Login from "./components/Login";
import Post from "./components/Post";
import SinglePost from "./components/SinglePost";
import Profile from "./components/Profile";
import Upload from "./components/Upload";
import Footer from "./components/Footer";
import { db, auth } from "./firebase";
import "./App.css";
import { useEffect, useState } from "react";
import { useStateValue } from "./StateProvider";
import loading from "./img/loading.json";
import Lottie from "lottie-react";


function App() {
  const [{ user }, dispatch] = useStateValue();

  const [posts, setPosts] = useState([]);
  var [isLoading, setLoading] = useState([]);

  useEffect(() => {
    db.collection("Posts")
      .orderBy("timestamp", "desc")
      .limit(10)
      .onSnapshot((s) => {
        setPosts(
          s.docs.map((doc) => ({
            id: doc.id,
            post: doc.data(),
          }))
        );
		setLoading(false)
      });
  }, []);

  useEffect(() => {
    auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        db.collection("Users")
          .doc(authUser.uid)
          .onSnapshot((snapshot) => {
            dispatch({
              type: "SET_USER",
              user: snapshot.data(),
            });
          });
      } else {
        dispatch({
          type: "SET_USER",
          user: null,
        });
      }
    });
  }, [dispatch]);

  return (
    <div className="App">
      <div className="filter"></div>
      <Router>
        <Switch>
          <Route exact path="/login">
            <Header />
            <Login />
            <Footer />
          </Route>
          <Route exact path="/signup">
            <Header />
            <Signup />
            <Footer />
          </Route>
          <Route exact path="/post/:id">
            <Header />
            <SinglePost />
            {user ? <Upload user={user} /> : ""}
            <Footer />
          </Route>
          <Route exact path="/user/:userid">
            <Header />
            <Profile />
            {user ? <Upload user={user} /> : ""}
            <Footer />
          </Route>
          <Route exact path="/">
            <Header />

            {isLoading ? (
              <div className="posts" height="200" width="200" align="center">
                <Lottie
                  style={{
                    width: 400,
                    height: 400,
                    marginLeft: -5,
                  }}
                  loop={true}
                  autoPlay={true}
                  animationData={loading}
                />
              </div>
            ) : (
              <div className="posts">
                {posts.map(({ id, post }) => (
                  <Post key={id} postId={id} user={user} post={post} />
                ))}
              </div>
            )}

            {user ? <Upload user={user} /> : ""}
            <Footer />
          </Route>
          <Route>
            <Redirect to="/" />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
